import { createContext, useContext, useEffect, useState } from 'react';
import { chromeLocalStorage } from './chrome-storage-polyfill';

const ConnectedWalletsContext = createContext({});

export const ConnectedWalletsProvider = ({ children }) => {
  const [connectedWallets, setConnectedWallets] = useState({});

  useEffect(() => {
    const updateConnectionAmount = () => {
      chromeLocalStorage.get('connectedWallets', (result) => {
        setConnectedWallets(result.connectedWallets || {});
      });
    };
    const listener = (changes) => {
      if ('connectedWallets' in changes) {
        updateConnectionAmount();
      }
    };
    updateConnectionAmount();

    chromeLocalStorage.onChanged.addListener(listener);
    return () => chromeLocalStorage.onChanged.removeListener(listener);
  }, []);

  return (
    <ConnectedWalletsContext.Provider value={connectedWallets}>
      {children}
    </ConnectedWalletsContext.Provider>
  );
};

export const useConnectedWallets = () => useContext(ConnectedWalletsContext);
